import { faRightFromBracket, faRightToBracket } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import { companyMemory } from "../../Objects/Memory/Memory"
import { formatWorkedMinutes } from "../../Objects/TimeClock/TimeClockSettings"
import type { TimeClockStatus } from "../../Objects/TimeClock/TimeClockStatus"
import { formatTimeInTimeZone } from "../../utils/timeZone"

interface TimeClockStatusBarProps {
  status: TimeClockStatus
}

export const TimeClockStatusBar: React.FC<TimeClockStatusBarProps> = ({ status }) => {
  const { t, i18n } = useTranslation("timeClock")

  const isIn = status.nextDirection === "In"

  return (
    <div className="fixed bottom-20 left-3 right-16 z-40 flex flex-wrap items-center gap-2 rounded-2xl border-2 border-orange-100 bg-white/95 px-3 py-2 shadow-lg backdrop-blur-xl lg:inset-x-0 lg:mx-auto lg:w-fit lg:max-w-[95vw] lg:flex-nowrap lg:gap-3 lg:rounded-full lg:bottom-3 lg:px-4">
      <span
        className={`flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold ${
          status.isWorking ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-600"
        }`}
      >
        <FontAwesomeIcon icon={isIn ? faRightToBracket : faRightFromBracket} />

        {status.isWorking
          ? t("my.status_working", {
              time: formatTimeInTimeZone(status.lastPunchAtUtc, i18n.language, companyMemory.timeZoneId),
            })
          : t("my.status_stopped")}
      </span>

      <span className="whitespace-nowrap rounded-full bg-orange-100 px-3 py-1 text-xs font-semibold text-orange-700">
        {t("my.worked_today")}: {formatWorkedMinutes(status.todayWorkedMinutes)}
      </span>

      {status.todayExpectedMinutes > 0 && (
        <span className="whitespace-nowrap rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
          {t("my.expected_today")}: {formatWorkedMinutes(status.todayExpectedMinutes)}
        </span>
      )}
    </div>
  )
}
